import React from "react";
import { Store } from "react-notifications-component";
import 'react-notifications-component/dist/theme.css';
import 'animate.css';

export function Alert(type, title, message){
    Store.addNotification({
        title: title,
        message: message,
        type: type,                         // 'default', 'success', 'info', 'warning'
        container: 'top-center',                // where to position the notifications
        animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
        animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
        dismiss: {
          duration: 8000 
        }
    });
}